export default __webpack_public_path__ + "static/media/scrabble-768w.094447ab.webp";